import { render } from "./price.vue?vue&type=template&id=2691cab9"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/price.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2691cab9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2691cab9', __exports__)) {
    console.log('reload')
    api.reload('2691cab9', __exports__)
  }
  
  module.hot.accept("./price.vue?vue&type=template&id=2691cab9", () => {
    console.log('re-render')
    api.rerender('2691cab9', render)
  })

}


export default __exports__